import PropTypes from 'prop-types';
import Decorator from 'clientDecorator';
import EngagementCard from 'apps/profile/components/engagement-card';
import EngagementIcon from 'apps/profile/components/engagement-icon';
import ModalTrigger from 'components/modals/modal-trigger';
import { formatGiftAmount, formatGiftType } from 'apps/profile/components/activity/activity-helpers';
import ContactResolver from 'apps/profile/components/activity/contact-resolver';
import { Link, LinkButton } from '@evertrue/et-components';

function formatDelimited(list = []) {
  return list.map((item = '') => item.split(';').join('; '));
}

const GiftFeedItem = ({
  gift = {},
  onContactNameClick,
  contactNameModal,
  contactNameLink,
  onAmountClick,
  amountModal,
  amountLink,
}) => {
  const renderName = () => {
    const displayName = (
      <ContactResolver
        contact_id={gift.contact_id}
        render={({ parsed_contact }) => {
          const name = parsed_contact.id ? Decorator.Contacts.getFullName(parsed_contact)?.trim?.() : gift.donor_name;
          return <span className="fs-exclude-data">{name || 'A Constituent'}</span>;
        }}
      />
    );

    if (onContactNameClick) {
      return (
        <LinkButton title="constituent" onClick={onContactNameClick}>
          {displayName}
        </LinkButton>
      );
    } else if (contactNameLink) {
      return (
        <Link title="constituent" href={contactNameLink}>
          {displayName}
        </Link>
      );
    } else if (contactNameModal) {
      return (
        <ModalTrigger modal={contactNameModal} title="View Contact Details">
          <span>{displayName}</span>
        </ModalTrigger>
      );
    }
    return displayName;
  };

  const renderAmount = () => {
    const formattedAmount = formatGiftAmount(gift.amount);

    if (onAmountClick) {
      return (
        <LinkButton title="gift" onClick={onAmountClick}>
          <span className="fs-exclude-data">{formattedAmount}</span>
        </LinkButton>
      );
    } else if (amountLink) {
      return (
        <Link title="gift" href={amountLink}>
          <span className="fs-exclude-data">{formattedAmount}</span>
        </Link>
      );
    } else if (amountModal) {
      return (
        <ModalTrigger modal={amountModal} title="View Gift Details">
          <a className="fs-exclude-data">{formattedAmount}</a>
        </ModalTrigger>
      );
    }
    return <span className="text-bold fs-exclude-data">{formattedAmount}</span>;
  };

  const renderDesignations = () => {
    const list = formatDelimited(gift.designations);
    const count = list.length;

    if (count === 0) return null;
    if (count === 1) {
      return (
        <span>
          {' to '}
          <span className="fs-exclude-data">
            <span className="text-bold">{list[0]}</span>
          </span>
        </span>
      );
    }
    if (count === 2) {
      return (
        <span>
          {' to '}
          <span className="fs-exclude-data">
            <span className="text-bold">{list[0]}</span>
          </span>
          {' and '}
          <span className="fs-exclude-data">
            <span className="text-bold">{list[1]}</span>
          </span>
        </span>
      );
    }
    return (
      <span>
        {' to '}
        <span className="fs-exclude-data">
          <span className="text-bold">{list[0]}</span>
        </span>
        {` and ${count - 1} other designations`}
      </span>
    );
  };

  const displayType = formatGiftType(gift.type);

  return (
    <EngagementCard
      className="engagement-card-event"
      title={
        <div>
          {renderName()}
          {' gave '}
          {renderAmount()}
          {renderDesignations()}
          {'. '}
          {displayType && <span className="text-light">{` (${displayType})`}</span>}
        </div>
      }
      date={gift.occurred_at}
      icon={<EngagementIcon size="40px" icon="gift" />}
    />
  );
};

GiftFeedItem.propTypes = {
  gift: PropTypes.object,
  onContactNameClick: PropTypes.func,
  contactNameModal: PropTypes.any,
  contactNameLink: PropTypes.string,
  onAmountClick: PropTypes.func,
  amountModal: PropTypes.any,
  amountLink: PropTypes.string,
};

export default GiftFeedItem;
